import React, { useContext, useEffect } from "react";
import { ProcedureType, TScreen } from "api/type";

// Import Contexts
import ScreenContext from "contexts/screen";

import ScreenScan from "./ScreenScan";
import ScreenScanInstructions from "./ScreenScanInstructions";
import { usePoseLandmarker } from "utils/customHook";
import { NormalText } from "components";

type RootOnboardingScanAllPosesProps = {};

const RootOnboardingScanAllPoses: React.FC<
  RootOnboardingScanAllPosesProps
> = () => {
  // Context and State Declarations
  const [screen, setScreen] = useContext(ScreenContext);

  // Custom Hooks
  const poseLandmarker = usePoseLandmarker();
  const [selectedProcedure, setSelectedProcedure] =
    React.useState<ProcedureType | null>(null);
  const [isInvalidProcedureValue, setIsInvalidProcedureValue] =
    React.useState<boolean>(false);

  // Effect: Set Screen to Video Screen
  useEffect(() => {
    setScreen(TScreen.BODY_SCAN_INSTRUCTIONS_SCREEN);
  }, [setScreen]);

  useEffect(() => {
    const currentUrl = window.location.search;
    const urlSearchParams = new URLSearchParams(currentUrl);
    const procedure = urlSearchParams.get("procedure");

    if (!Object.values(ProcedureType).includes(procedure as ProcedureType)) {
      setIsInvalidProcedureValue(true);
      return;
    }
    setSelectedProcedure(procedure as ProcedureType);
  }, []);

  // Render Screen based on the current context
  const renderScreen = () => {
    switch (screen) {
      case TScreen.BODY_SCAN_INSTRUCTIONS_SCREEN:
        return <ScreenScanInstructions />;
      case TScreen.BODY_SCAN_SCREEN:
        return (
          <ScreenScan
            poseLandmarker={poseLandmarker}
            selectedProcedure={selectedProcedure}
          />
        );
      default:
        return null;
    }
  };

  if (!selectedProcedure) return null;

  if (isInvalidProcedureValue) {
    return (
      <div style={{ padding: "20px" }}>
        <NormalText textContent="Invalid procedure, please check the documentation for a list of valid procedures" />
        <a
          href="https://github.com/ClinicOS-AI/integration-guide/blob/main/photo_capture.md"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://github.com/ClinicOS-AI/integration-guide/blob/main/photo_capture.md
        </a>
      </div>
    );
  }

  return <div id="onboarding-advertise-container">{renderScreen()}</div>;
};

export default RootOnboardingScanAllPoses;
